import React, { createContext, useEffect, useReducer } from 'react';
import { LOGIN, LOGOUT } from 'store/reducers/actions';
import authReducer from 'store/reducers/auth';
import axios from 'lib/axios';
import { AuthProps, JWTContextType } from 'types/auth';
import { useAuthCheck } from 'hooks/useAuthCheck';
import Loader from 'components/common/Loader/Loader';
import { IS_EFP, KEYCLOAK_URI, KEYCLOAK_REALM, CLIENT_ID } from 'config';

const initialState: AuthProps = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
};

const JWTContext = createContext<JWTContextType | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactElement }) => {
    const { checkAuth, isLoading } = useAuthCheck();
    const [state, dispatch] = useReducer(authReducer, initialState);

    useEffect(() => {
        const init = async () => {
            const auth = await checkAuth({ showErrorToast: false });

            if (auth && auth.status === 202) {
                const response = await axios.get('/oauth2/userinfo');
                const { user } = response.data;

                dispatch({
                    type: LOGIN,
                    payload: {
                        isLoggedIn: true,
                        user,
                    },
                });
            } else {
                dispatch({
                    type: LOGOUT,
                });
                localStorage.clear();
            }
        };

        init();
    }, []);

    const logout = () => {
        dispatch({ type: LOGOUT });
        const rd_url = encodeURIComponent(`${window.location.protocol}//${window.location.host}/login`);
        const rd_url_efp = `${window.location.protocol}//${window.location.host}/login`;
        const kc_logout_uri =
            `${KEYCLOAK_URI}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/logout?client_id=${CLIENT_ID}&post_logout_redirect_uri=` +
            rd_url;

        location.replace(
            `${window.location.protocol}//${window.location.host}/oauth2/sign_out?rd=${encodeURIComponent(
                IS_EFP ? rd_url_efp : kc_logout_uri
            )}`
        );
    };

    const updateProfile = () => {};

    if (isLoading) {
        return <Loader />;
    }
    return <JWTContext.Provider value={{ ...state, logout, updateProfile }}>{children}</JWTContext.Provider>;
};

export default JWTContext;
